import React from "react";
import "./Services.css";
import { motion } from "framer-motion";
import { servicesData } from "../../data/services.data";
import { motionProps, servicesContainer } from "../../animations";
import ServiceCard from "./ServiceCard";
import AnimatedHeadings from "../animatedHeadings/AnimatedHeadings";

const Services = () => {
  return (
    <section id="services">
      <AnimatedHeadings smallTitle="What I Offer" mainTitle="Services" />

      {/* Cards */}
      <motion.div
        className="container services__container"
        variants={servicesContainer}
        {...motionProps}
      >
        {servicesData.map((service) => (
          <ServiceCard key={service.title} {...service} />
        ))}
      </motion.div>
    </section>
  );
};

export default Services;
